import React, { ReactElement, ReactNode } from "react";

import useProjectScene from "../../hooks/use-project-scene";
import { Size } from "../../types/size";

export default function AspectRatioOverlay(props: {
  children: ReactNode;
  aspectRatio: number;
  canvasSize: Size;
}): ReactElement {
  const { aspectRatio, children, canvasSize } = props;

  const { selection } = useProjectScene();

  const zIndex = 11;
  const commonStyles: React.CSSProperties = {
    position: "absolute" as const,
    background: selection.backgroundColor,
    zIndex,
    opacity: 0.5,
    pointerEvents: "none",
  };

  return (
    <div className="left-0 top-0 h-full w-full">
      {canvasSize.width / aspectRatio < canvasSize.height && (
        <div
          style={{
            height: `${(canvasSize.width - canvasSize.width / aspectRatio) / 2}px`,
            ...commonStyles,
          }}
          className="left-0 top-0 w-full"
        />
      )}
      {canvasSize.width / aspectRatio > canvasSize.width && (
        <div
          style={{
            width: `${(canvasSize.height - canvasSize.height * aspectRatio) / 2}px`,
            ...commonStyles,
          }}
          className="left-0 top-0 h-full"
        />
      )}
      {canvasSize.width / aspectRatio < canvasSize.height && (
        <div
          style={{
            height: `${(canvasSize.width - canvasSize.width / aspectRatio) / 2}px`,
            ...commonStyles,
          }}
          className="bottom-0 left-0 w-full"
        />
      )}
      {canvasSize.width / aspectRatio > canvasSize.width && (
        <div
          style={{
            width: `${(canvasSize.height - canvasSize.height * aspectRatio) / 2}px`,
            ...commonStyles,
          }}
          className="right-0 top-0 h-full"
        />
      )}
      {children}
    </div>
  );
}
